/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const OpenDataSource = {
    Act: 'AUS_ACT',
    Nsw: 'AUS_NSW',
    Qld: 'AUS_QLD',
    Sa: 'AUS_SA',
    Tas: 'AUS_TAS',
    Vic: 'AUS_VIC',
    Wa: 'AUS_WA'
};
export function OpenDataSourceFromJSON(json) {
    return OpenDataSourceFromJSONTyped(json, false);
}
export function OpenDataSourceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function OpenDataSourceToJSON(value) {
    return value;
}
